import request from "superagent";

// Utility function to handle any errors
function handleError(error) {
    let status;
    let message;
    //Error in response
    if (error.response) {
        let res = error.response;
        // Set status
        status = res.status || 500;
        // Message
        switch (res.type) {
            case "application/json":
                message = res.body.message;
                break;
            default:
                message = res.text;
        }
    }
    // Something else happened!
    else {
        status = 0;
        message = error.message || "Unknown error occurred";
    }
    // Done
    return {
        status: status,
        message: message
    };
}

// B2B
const b2b = {
    // Referral
    referral: {
        // Get
        getInfo: function (code) {
            return new Promise(async (resolve, reject) => {
                try {
                    // Call
                    const res = await request
                        .get("https://api.storecashapp.com/prd/con?s=b&code=" + code)
                        .timeout(20000);
                    // Done
                    resolve(res.body);
                } catch (err) {
                    reject(handleError(err));
                }
            });
        }
    }
};

// B2C
const b2c = {
    // Referral
    referral: {
        // Get
        getInfo: function (code) {
            return new Promise(async (resolve, reject) => {
                try {
                    // Call
                    const res = await request
                        .get("https://api.storecashapp.com/prd/con?s=c&code=" + code)
                        .timeout(20000);
                    // Done
                    resolve(res.body);
                } catch (err) {
                    reject(handleError(err));
                }
            });
        }
    }
};

/**
 * Export
 */
export default {
    b2b,
    b2c
};